import { render, staticRenderFns } from "./ObsRecordButton.vue?vue&type=template&id=50b06df4&"
import script from "./ObsRecordButton.vue?vue&type=script&lang=js&"
export * from "./ObsRecordButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports